import { cms } from "./index"

export function fetchSponsors() {
  return cms.get("endurance-sponsors")
}